import React, { useState } from 'react';

function PensionGuide() {
  const [activeTab, setActiveTab] = useState('overview');

  const tabContent = {
    overview: {
      title: '연금 제도 개요',
      icon: 'fas fa-home',
      content: (
        <div>
          <div className="alert alert-info">
            <h5 className="alert-heading">
              <i className="fas fa-lightbulb me-2"></i>
              우리나라의 다층 연금 체계
            </h5>
            <p className="mb-0">
              우리나라는 <strong>3층 구조의 연금 체계</strong>를 운영하고 있습니다. 
              각 층별로 역할이 다르므로 전체적인 이해가 필요합니다.
            </p>
          </div>

          <div className="row">
            <div className="col-lg-4 mb-4">
              <div className="card border-primary h-100">
                <div className="card-header bg-primary text-white">
                  <h5 className="mb-0">
                    <i className="fas fa-building me-2"></i>
                    1층: 국민연금
                  </h5>
                </div>
                <div className="card-body">
                  <p><strong>공적연금 (의무가입)</strong></p>
                  <ul>
                    <li>모든 국민이 가입하는 기본 연금</li>
                    <li>소득의 9% 납부 (본인 4.5%, 사업자 4.5%)</li>
                    <li>국가가 운영하는 가장 안전한 연금</li>
                    <li>인플레이션 보정 및 장수 리스크 보장</li>
                  </ul>
                  <div className="badge bg-primary">기초 생활 보장</div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 mb-4">
              <div className="card border-success h-100">
                <div className="card-header bg-success text-white">
                  <h5 className="mb-0">
                    <i className="fas fa-briefcase me-2"></i>
                    2층: 퇴직연금
                  </h5>
                </div>
                <div className="card-body">
                  <p><strong>기업연금 (의무가입)</strong></p>
                  <ul>
                    <li>DB형: 회사가 약속한 금액 지급</li>
                    <li>DC형: 개인이 운용, 결과에 따라 수령액 변동</li>
                    <li>IRP: 개인형 퇴직연금계좌</li>
                    <li>연간 300만원 세액공제 혜택</li>
                  </ul>
                  <div className="badge bg-success">적정 생활 보장</div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 mb-4">
              <div className="card border-warning h-100">
                <div className="card-header bg-warning text-white">
                  <h5 className="mb-0">
                    <i className="fas fa-piggy-bank me-2"></i>
                    3층: 개인연금
                  </h5>
                </div>
                <div className="card-body">
                  <p><strong>사적연금 (선택가입)</strong></p>
                  <ul>
                    <li>연금저축: 연간 600만원 세액공제</li>
                    <li>ISA: 개인종합자산관리계좌</li>
                    <li>개인적으로 준비하는 추가 노후자금</li>
                    <li>투자 상품 선택의 자유도 높음</li>
                  </ul>
                  <div className="badge bg-warning">풍요로운 노후</div>
                </div>
              </div>
            </div>
          </div>

          <div className="card bg-light mt-4">
            <div className="card-body">
              <h5 className="text-primary">
                <i className="fas fa-calculator me-2"></i>
                노후 준비의 현실
              </h5>
              <p className="mb-3">
                일반적으로 노후에는 현역 시절 소득의 <strong>70-80%</strong> 정도가 필요하다고 합니다. 
                하지만 국민연금만으로는 약 <strong>40%</strong> 정도만 보장됩니다.
              </p>
              <div className="row text-center">
                <div className="col-md-4">
                  <div className="bg-white p-3 rounded">
                    <h6 className="text-primary">국민연금</h6>
                    <h4 className="text-primary">40%</h4>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="bg-white p-3 rounded">
                    <h6 className="text-success">퇴직연금</h6>
                    <h4 className="text-success">20%</h4>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="bg-white p-3 rounded">
                    <h6 className="text-warning">개인연금</h6>
                    <h4 className="text-warning">10-20%</h4>
                  </div>
                </div>
              </div>
              <p className="mt-3 mb-0 text-center">
                <small className="text-muted">
                  따라서 <strong>개인연금과 퇴직연금</strong>을 통한 추가 준비가 필수적입니다.
                </small>
              </p>
            </div>
          </div>
        </div>
      )
    },
    
    taxbenefits: {
      title: '절세 상품 3총사',
      icon: 'fas fa-coins',
      content: (
        <div>
          <div className="alert alert-success">
            <h5 className="alert-heading">
              <i className="fas fa-percentage me-2"></i>
              세액공제로 노후자금 늘리기
            </h5>
            <p className="mb-0">
              연금저축, IRP, ISA를 활용하면 <strong>세금을 절약하면서</strong> 노후자금을 늘릴 수 있습니다. 
              단순 적금 대비 약 <strong>1.5-2배</strong> 더 많은 자금을 만들 수 있습니다.
            </p>
          </div>

          <div className="row">
            <div className="col-lg-4 mb-4">
              <div className="card border-primary h-100">
                <div className="card-header">
                  <h5 className="text-primary mb-0">
                    <i className="fas fa-piggy-bank me-2"></i>
                    연금저축
                  </h5>
                </div>
                <div className="card-body">
                  <div className="mb-3">
                    <span className="badge bg-primary">연간 최대 600만원</span>
                  </div>
                  <h6>특징</h6>
                  <ul className="list-unstyled">
                    <li><i className="fas fa-check text-success me-2"></i>누구나 가입 가능</li>
                    <li><i className="fas fa-check text-success me-2"></i>세액공제 600만원</li>
                    <li><i className="fas fa-check text-success me-2"></i>과세이연 효과</li>
                    <li><i className="fas fa-check text-success me-2"></i>5년 의무가입</li>
                  </ul>
                  
                  <h6 className="mt-3">수령 시 세율</h6>
                  <ul className="list-unstyled">
                    <li><small>55세 이후: 연금소득세 3.3-5.5%</small></li>
                    <li><small>중도해지: 기타소득세 16.5%</small></li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-4 mb-4">
              <div className="card border-success h-100">
                <div className="card-header">
                  <h5 className="text-success mb-0">
                    <i className="fas fa-briefcase me-2"></i>
                    IRP (개인형 퇴직연금)
                  </h5>
                </div>
                <div className="card-body">
                  <div className="mb-3">
                    <span className="badge bg-success">연간 최대 300만원</span>
                  </div>
                  <h6>특징</h6>
                  <ul className="list-unstyled">
                    <li><i className="fas fa-check text-success me-2"></i>소득 있는 누구나</li>
                    <li><i className="fas fa-check text-success me-2"></i>퇴직금 이체 필수</li>
                    <li><i className="fas fa-check text-success me-2"></i>안전자산 30% 의무</li>
                  </ul>
                  
                  <h6 className="mt-3">세액공제 조건</h6>
                  <ul className="list-unstyled">
                    <li><small>연금저축과 합산 최대 900만원</small></li>
                    <li><small>총급여액 5,500만원 이하: 16.5% 공제</small></li>
                    <li><small>총급여액 5,500만원 초과: 13.2% 공제</small></li>
                    <li><small>※ 종합소득금액 기준: 4,500만원 이하/초과</small></li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-4 mb-4">
              <div className="card border-warning h-100">
                <div className="card-header">
                  <h5 className="text-warning mb-0">
                    <i className="fas fa-chart-line me-2"></i>
                    ISA (개인종합자산관리계좌)
                  </h5>
                </div>
                <div className="card-body">
                  <div className="mb-3">
                    <span className="badge bg-warning">연간 최대 2,000만원</span>
                  </div>
                  <h6>특징</h6>
                  <ul className="list-unstyled">
                    <li><i className="fas fa-check text-success me-2"></i>만 19세 이상 가능</li>
                    <li><i className="fas fa-check text-success me-2"></i>국내주식 매매차익 비과세</li>
                    <li><i className="fas fa-check text-success me-2"></i>손익통산 가능</li>
                    <li><i className="fas fa-check text-success me-2"></i>3년 의무가입</li>
                  </ul>
                  
                  <h6 className="mt-3">비과세 한도</h6>
                  <ul className="list-unstyled">
                    <li><small>일반형: 연간 200만원</small></li>
                    <li><small>서민형: 연간 400만원</small></li>
                    <li><small>초과분: 9.9% 분리과세</small></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="card bg-light">
            <div className="card-body">
              <h5 className="text-primary mb-3">
                <i className="fas fa-route me-2"></i>
                가입 우선순위 가이드
              </h5>
              <div className="row">
                <div className="col-md-4 text-center mb-3">
                  <div className="bg-primary text-white p-3 rounded">
                    <h6>1단계: ISA</h6>
                    <p className="mb-0 small">주식투자를 하고 있다면 가장 먼저!</p>
                  </div>
                </div>
                <div className="col-md-4 text-center mb-3">
                  <div className="bg-success text-white p-3 rounded">
                    <h6>2단계: 연금저축</h6>
                    <p className="mb-0 small">세액공제가 필요하고 노후대비 인식이 있다면</p>
                  </div>
                </div>
                <div className="col-md-4 text-center mb-3">
                  <div className="bg-warning text-white p-3 rounded">
                    <h6>3단계: IRP</h6>
                    <p className="mb-0 small">600만원 채우고도 여유자금이 있다면</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    },

    practical: {
      title: '실전 가이드',
      icon: 'fas fa-tasks',
      content: (
        <div>
          <div className="alert alert-primary">
            <h5 className="alert-heading">
              <i className="fas fa-rocket me-2"></i>
              지금 당장 할 수 있는 Action Plan
            </h5>
            <p className="mb-0">
              연금과 절세에 대해 배웠다면, 이제 <strong>실제로 행동에 옮겨야</strong> 합니다. 
              단계별로 차근차근 진행해보세요.
            </p>
          </div>

          <div className="row">
            <div className="col-lg-6 mb-4">
              <div className="card border-primary h-100">
                <div className="card-header bg-primary text-white">
                  <h5 className="mb-0">
                    <i className="fas fa-list-ol me-2"></i>
                    Step 1: 현황 파악
                  </h5>
                </div>
                <div className="card-body">
                  <div className="checklist">
                    <div className="form-check mb-2">
                      <input className="form-check-input" type="checkbox" id="check1" />
                      <label className="form-check-label" htmlFor="check1">
                        <strong>국민연금 예상 수령액 확인</strong>
                        <br /><small className="text-muted">국민연금 홈페이지 → 내 연금 알아보기</small>
                      </label>
                    </div>
                    
                    <div className="form-check mb-2">
                      <input className="form-check-input" type="checkbox" id="check2" />
                      <label className="form-check-label" htmlFor="check2">
                        <strong>퇴직연금 종류 확인</strong>
                        <br /><small className="text-muted">DB형 vs DC형 vs IRP 중 어느 것인지</small>
                      </label>
                    </div>
                    
                    <div className="form-check mb-2">
                      <input className="form-check-input" type="checkbox" id="check3" />
                      <label className="form-check-label" htmlFor="check3">
                        <strong>연금저축 가입 현황 확인</strong>
                        <br /><small className="text-muted">이미 가입했다면 얼마나 납입하고 있는지</small>
                      </label>
                    </div>
                    
                    <div className="form-check mb-2">
                      <input className="form-check-input" type="checkbox" id="check4" />
                      <label className="form-check-label" htmlFor="check4">
                        <strong>작년 결정세액 확인</strong>
                        <br /><small className="text-muted">원천징수영수증 or 종합소득세 신고서</small>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 mb-4">
              <div className="card border-success h-100">
                <div className="card-header bg-success text-white">
                  <h5 className="mb-0">
                    <i className="fas fa-play me-2"></i>
                    Step 2: 우선순위 실행
                  </h5>
                </div>
                <div className="card-body">
                  <div className="timeline">
                    <div className="timeline-item mb-3">
                      <div className="timeline-marker bg-primary"></div>
                      <div className="timeline-content">
                        <h6 className="text-primary">1순위: ISA 가입</h6>
                        <p className="mb-1">주식투자를 하고 있다면 무조건 ISA부터!</p>
                        <small className="text-muted">국내주식 매매차익 비과세 혜택</small>
                      </div>
                    </div>
                    
                    <div className="timeline-item mb-3">
                      <div className="timeline-marker bg-success"></div>
                      <div className="timeline-content">
                        <h6 className="text-success">2순위: 연금저축</h6>
                        <p className="mb-1">세액공제가 필요하고 노후대비 의지가 있다면</p>
                        <small className="text-muted">연간 600만원 한도</small>
                      </div>
                    </div>
                    
                    <div className="timeline-item">
                      <div className="timeline-marker bg-warning"></div>
                      <div className="timeline-content">
                        <h6 className="text-warning">3순위: IRP 추가납입</h6>
                        <p className="mb-1">연금저축 600만원 채우고도 여유가 있다면</p>
                        <small className="text-muted">연간 300만원 추가 한도</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card bg-light mb-4">
            <div className="card-body">
              <h5 className="text-info mb-3">
                <i className="fas fa-calculator me-2"></i>
                납입액 결정 가이드
              </h5>
              
              <div className="row">
                <div className="col-md-6">
                  <div className="card bg-white">
                    <div className="card-body">
                      <h6 className="text-success">
                        <i className="fas fa-plus-circle me-2"></i>
                        세금을 추가로 내는 경우
                      </h6>
                      <p className="small mb-2">연말정산이나 종합소득세 신고 후 추가 납부하는 경우</p>
                      <div className="alert alert-success alert-sm">
                        <strong>추천:</strong> 연금저축 600만원 + IRP 300만원<br />
                        <small>세액공제 효과를 최대한 활용</small>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="col-md-6">
                  <div className="card bg-white">
                    <div className="card-body">
                      <h6 className="text-primary">
                        <i className="fas fa-minus-circle me-2"></i>
                        세금을 돌려받는 경우
                      </h6>
                      <p className="small mb-2">연말정산 후 환급받는 경우</p>
                      <div className="alert alert-primary alert-sm">
                        <strong>추천:</strong> 연금저축 600만원부터<br />
                        <small>중도인출이 상대적으로 쉬운 연금저축 우선</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      )
    }
  };

  return (
    <div className="bg-gradient-primary min-vh-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-12 col-lg-12">
            
            {/* 헤더 */}
            <div className="text-center py-5">
              <h1 className="h1 text-white mb-4">
                <i className="fas fa-graduation-cap me-3"></i>
                연금 완전 정복 가이드
              </h1>
              <p className="lead text-white-50 mb-0">
                연금부터 절세까지, 노후 준비의 모든 것
              </p>
            </div>

            {/* 탭 네비게이션 */}
            <div className="card shadow mb-4">
              <div className="card-header">
                <ul className="nav nav-tabs card-header-tabs" role="tablist">
                  {Object.entries(tabContent).map(([key, tab]) => (
                    <li className="nav-item" key={key}>
                      <button
                        className={`nav-link ${activeTab === key ? 'active' : ''}`}
                        onClick={() => setActiveTab(key)}
                      >
                        <i className={`${tab.icon} me-2`}></i>
                        {tab.title}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="card-body">
                {tabContent[activeTab].content}
              </div>
            </div>

            {/* 하단 안내 */}
            <div className="card shadow mb-4">
              <div className="card-body text-center">
                <h5 className="text-primary mb-3">
                  <i className="fas fa-calculator me-2"></i>
                  계산기로 실습해보기
                </h5>
                <p className="text-gray-600 mb-3">
                  이론을 배웠다면 이제 실제로 계산해보세요!<br />
                  본인의 상황에 맞는 노후 계획을 세워보실 수 있습니다.
                </p>
                <div className="row justify-content-center">
                  <div className="col-md-6">
                    <button className="btn btn-primary btn-lg w-100 mb-2">
                      <i className="fas fa-calculator me-2"></i>
                      일반 계산기 사용하기
                    </button>
                    <button className="btn btn-success btn-lg w-100">
                      <i className="fas fa-bullseye me-2"></i>
                      역산 계산기 사용하기
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      
      <style jsx>{`
        .timeline-item {
          position: relative;
          padding-left: 30px;
        }
        .timeline-marker {
          position: absolute;
          left: 0;
          top: 5px;
          width: 15px;
          height: 15px;
          border-radius: 50%;
        }
        .checklist .form-check-input:checked {
          background-color: #28a745;
          border-color: #28a745;
        }
        .alert-sm {
          padding: 0.5rem;
          font-size: 0.875rem;
        }
      `}</style>
    </div>
  );
}

export default PensionGuide;